import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationFa from "assets/langs/fa.json";
import translationEn from "assets/langs/en.json";
import { initReactI18next } from "react-i18next";

const options = {
  resources: {
    en: {
      translation: translationEn,
    },
    fa: {
      translation: translationFa,
    },
  },
  fallbackLng: "fa",
  debug: false,
  react: {
    wait: true,
  },
};

i18n?.use(Backend)?.use(initReactI18next)?.use(LanguageDetector)?.init(options);

export default i18n;
